import { Component } from 'react';
import styled from 'styled-components';

import { pcVisitedLink } from '../../../../../common/css/setting/mixin';
import { SportsItemStyle } from './sportsCommonStyle';

interface IProps {
  url: string;
  name: string;
  dataClParams: string;
}

const BaseballItem = styled.li`
  ${SportsItemStyle}
`;

const BaseballLink = styled.a`
  ${pcVisitedLink}
`;

export default class BaseballPlayer extends Component<IProps> {
  /**
   *
   */
  public render() {
    return (
      <BaseballItem>
        <BaseballLink href={this.props.url} data-cl-params={this.props.dataClParams}>
          {this.props.name}
        </BaseballLink>
      </BaseballItem>
    );
  }
}
